import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, switchMap, tap } from 'rxjs';
import { BlService } from 'src/app/_services/bl/bl.service';
import { BlDetails, ClientesBl } from 'src/app/interfaces/bl.interfaces';
import { Customer, CustomerBusinessName, CustomsEmbargoedMerchandise, EmbargoedMerchandise, Material, MaterialGroup, Packaging, PreviousRegistration, PreviousRegistrationSampleCollection } from 'src/app/interfaces/lotes.interfaces';
import { CabotageBatch } from 'src/app/interfaces/cabotageBatches.interfaces';
import { FileBatchExportation } from 'src/app/interfaces/exportationBatches.interfaces';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
export interface AnnexFile {
  file_id: number;
  file:    string;
}

/**
 * Componente de formulario para crear, consultar o actualizar un lote de cabotaje,
 * gestionando los datos del cliente, material, anexos, registros previos y mercancías embargadas.
 */
@Component({
  selector: 'app-form-lote-cabotaje',
  templateUrl: './form-lote-cabotaje.component.html',
  styles: [
    `
    h2 {
      margin: 0;
    }
    .btn-lote.btn-registro {
      width: 100%;
      height: 38px;
    }
    .rule238 {
      color: #fff;
      background-color: #455660;
    }
    .rule238:hover {
      color: #455660;
      background-color: #fff;
    }
    `
  ]
})
export class FormLoteCabotajeComponent implements OnInit {
  @Input() movimiento: string = 'crear';
  @Input() clientesBl: ClientesBl[] = [];
  @Input() idCliente: number = 0;
  @Input() blDetails: BlDetails = {
    operation_number:     0,
    boats_name:           '',
    operation_type_number:0,
    bl_tonnage:           0,
    customer_name:        null,
    date_time_capture:    '',
    dock_name:            '',
    port_origin_name:     '',
    start_operations:     '',
    end_operations:       '',
    boat_nationality:     '',
    destination_port:     '',
    operation_id:         0,
    docking_date:         '',
    undocking_date:       '',
    bl_master:            '',
    notice_of_readiness:  '',
  };
  bl_id: number = 0;
  textRule238: string = 'Mostrar regla 2.3.8';
  rule238: boolean = false;
  exportationBatchForm: FormGroup;
  errorMessage: string = 'Ingrese el archivo';
  mensajeError2: string = 'Ingrese el archivo';
  maxSize: boolean = false;
  maxSize2: boolean = false;
  filesUrl: string[] = [];
  materials: Material[] = [];
  customers: Customer[] = [];
  customersBusinessName: CustomerBusinessName[] = [];
  packagings: Packaging[] = [];
  materialGroups: MaterialGroup[] = [];
  material: string = '';
  id_business_name: string = '';
  overlay: boolean = false;
  icono: string = '';
  mensaje: string = '';
  buttons: boolean = false;
  loading: boolean = false;
  currentPath: string = '';
  bachId: number = 0;
  exportationBatch: CabotageBatch = {
    bl_lot_id:                               '',
    customer_lot_number:                     '',
    customer_id:                             0,
    client_name:                             '',
    id_business_name:                        0,
    material_group_id:                       0,
    material_group_name:                     '',
    material_id:                             0,
    material_name:                           '',
    packing_id:                              0,
    packaging:                               '',
    observations:                            '',
    tonnage:                                 0,
    quantity_pieces:                         0,
    days_free_storage:                       0,
    storage_fee:                             0,
    special_storage_rate:                    0,
    consignee_name:                          '',
    address_consignee:                       '',
    commercial_value:                        0,
    shipper_receiver:                        '',
    address_shipper_receiver:                '',
    damage_violation_record:                 '',
    identification_stored_merchandise:       '',
    volume_occupied_merchandise:             0,
    merchandise_fiscalized_area:             false,
    pama_number:                             '',
    fiscal_folio_cfdi:                       '',
    total_amount_cfdi:                       '',
    total_amount_presentation:               '',
    amount_merchandise_deposit:              '',
    compensation_amount:                     '',
    address_business:                        '',
    container_dimension:                     '',
    container_type:                          '',
    number_container_seals:                  '',
    number_container_locks:                  '',
    unconsolidated_container:                '',
    deconsolidated_store:                    '',
    unconsolidated_means_transport:          '',
    origin:                            '',
    destination:                              '',
    customs_agent: '',
    consolidated_container:                  '',
    consolidated_store:                      '',
    consolidated_means_transport:            '',
    file_cabotage_batch:                       '',
  };
  previousRegistration: PreviousRegistration[] = [];
  embargoedMerchandise: EmbargoedMerchandise[] = [];
  file: FileBatchExportation = {
    url: ''
  };
  client_name: string = '';
  address: string = '';
  client: Customer | undefined = {
    id:            0,
    name:          '',
    business_name: '',
  };
  asterico: string = '';
  annex_files: AnnexFile[] = [
    {
      file_id: 1,
      file: ""
    },
    {
      file_id: 2,
      file: ""
    },
    {
      file_id: 3,
      file: ""
    },
    {
      file_id: 4,
      file: ""
    },
    {
      file_id: 5,
      file: ""
    }
  ];
  overlayError: boolean = false;
  maxSizeAnnex1: boolean = false;
  maxSizeAnnex2: boolean = false;
  maxSizeAnnex3: boolean = false;
  maxSizeAnnex4: boolean = false;
  maxSizeAnnex5: boolean = false;
  errorAnnex1: string = '';
  errorAnnex2: string = '';
  errorAnnex3: string = '';
  errorAnnex4: string = '';
  errorAnnex5: string = '';
  annexUrls: string[] = [];

  constructor(
  private fb: FormBuilder,
  private blServices: BlService,
  private loteService: LoteService,
  private loteCabotajeService: LoteCabotajeService,
  private location: Location,
  private router: Router,
  private activatedRoute: ActivatedRoute,
  ){
    this.exportationBatchForm = this.fb.group({
      customer_lot_number: [],
      bl_lot_id: [],
      customer_id: ['', [Validators.required]],
      id_business_name: ['', [Validators.required]],
      address_business: [, [Validators.required, Validators.maxLength(200)]],
      material_group_id: ['', [Validators.required]],
      material_id: ['', [Validators.required]],
      origin: [, [Validators.required]],
      packing_id: ['', [Validators.required]],
      observations: [],
      commercial_value: [, [Validators.pattern(/^[0-9]{1,14}(\.[0-9]{1,2})?$/)]],
      tonnage: [0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,3})?$/)]],
      quantity_pieces: [, [Validators.pattern(/^[0-9]+$/)]],
      days_free_storage: [30, [Validators.required, Validators.pattern('^[0-9]\\d*$')]],
      storage_fee: [0.04, [Validators.required]],
      special_storage_rate: [0, [Validators.required, Validators.pattern(/^[0-9]{1,10}(\.[0-9]{1,3})?$/)]],
      previous_registration_sample_collection: this.fb.array([]),
      shipper_receiver : [],
      address_shipper_receiver: [],
      consignee_name: [],
      address_consignee: [],
      pama_number: [, [Validators.maxLength(150)]],
      fiscal_folio_cfdi: [, [Validators.maxLength(150)]],
      total_amount_cfdi: [, [Validators.maxLength(150)]],
      total_amount_presentation: [, [Validators.maxLength(150)]],
      amount_merchandise_deposit: [, [Validators.maxLength(150)]],
      compensation_amount: [, [Validators.maxLength(150)]],
      damage_violation_record: [],
      customs_embargoed_merchandise: this.fb.array([]),
      identification_stored_merchandise: [],
      volume_occupied_merchandise: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      container_dimension: [, [Validators.maxLength(150)]],
      container_type: [, [Validators.maxLength(150)]],
      number_container_seals: [, [Validators.maxLength(150)]],
      number_container_locks: [, [Validators.maxLength(150)]],
      unconsolidated_container: [, [Validators.maxLength(150)]],
      deconsolidated_store: [, [Validators.maxLength(150)]],
      unconsolidated_means_transport: [, [Validators.maxLength(150)]],
      consolidated_container: [, [Validators.maxLength(150)]],
      consolidated_store: [, [Validators.maxLength(150)]],
      consolidated_means_transport: [, [Validators.maxLength(150)]],
      client_name: [],
      material_group_name: [],
      material_name: [],
      packaging: [],
      file_cabotage_batch: [],
      invoice_uuid: [, [Validators.maxLength(36)]]
    });
  }

  get registrosPreviosTomaMuestraArr() {
    return this.exportationBatchForm.get('previous_registration_sample_collection') as FormArray;
  }

  get mercanciasEmbargadasAduanaArr() {
    return this.exportationBatchForm.get('customs_embargoed_merchandise') as FormArray;
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.currentPath = this.router.url;
    this.blServices.path = '';
    this.loading = true;
    if (!this.currentPath.includes('/batch-create')) {
      this.bachId = Number(this.activatedRoute.snapshot.paramMap.get('batchId'));
    }
    forkJoin([this.loteService.getCustomer(), this.loteService.getMaterialGroup(), this.loteService.getPackaging()])
    .subscribe({
      next: ([customers, materialGroups, packagings]) => {
        this.customers = this.sortArray<Customer>(customers, 'name');
        this.materialGroups = this.sortArray<MaterialGroup>(materialGroups, 'description');
        this.packagings = this.sortArray<Packaging>(packagings, 'description');
        if (this.currentPath.includes('/batch-create')) {
          if (this.router.url.includes('/ship-list')) {
            this.bl_id = this.clientesBl[this.idCliente - 1].bl_id;
            this.client = this.customers.find( client => this.clientesBl[this.idCliente - 1].customer_id == client.id);
            if (this.client) {
              this.exportationBatchForm.get('client_name')?.setValue(this.client.name);
              this.exportationBatchForm.get('customer_id')?.setValue(this.client.id);
              this.exportationBatchForm.get('customer_id')?.disable();
              this.loteService.getCustomerBusinessName(this.client.id).subscribe( customerBusinessName => this.customersBusinessName = [...customerBusinessName])
            }
            const materialGroup  = this.materialGroups.find( item => this.clientesBl[this.idCliente - 1].material_id == item.id);
            if (materialGroup) {
              this.exportationBatchForm.get('material_group_id')?.setValue(materialGroup.id);
              this.exportationBatchForm.get('material_group_id')?.disable();
              this.exportationBatchForm.get('material_group_name')?.setValue(materialGroup.description);
              this.loteService.getMaterial( `${materialGroup.id}` ).subscribe( materials => {
                this.materials = this.sortArray<Material>(materials, 'description');
              });
            }
          }
          this.loading = false;
        }
      },
      error: (e) => {
        this.loading = false;
        this.overlayError = true;
      },
    });
    if (this.currentPath.includes('/batch-create')) {
      this.exportationBatchForm.get('address_business')?.disable();
    }

    if (!this.currentPath.includes('/ship-list')) {
      this.exportationBatchForm.get('customer_id')?.valueChanges
      .pipe(
        tap((_) => {
          this.exportationBatchForm.get('id_business_name')?.reset(this.id_business_name);
        }),
        switchMap( ( material_group ) => {
          const client = this.customers.find( client => client.id == material_group);
          this.exportationBatchForm.get('client_name')?.setValue(client?.name);
          return this.loteService.getCustomerBusinessName( material_group )
        })
      ).subscribe({
        next: customerBusinessName => this.customersBusinessName = this.sortArray<CustomerBusinessName>(customerBusinessName, 'business_name'),
        error: (e) => {
          this.mensaje = 'Error en el servidor al cargar las razones sociales, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });

      this.exportationBatchForm.get('material_group_id')?.valueChanges
      .pipe(
        tap((_) => {
          this.exportationBatchForm.get('material_id')?.reset(this.material);
        }),
        switchMap( ( material_group ) => this.loteService.getMaterial( material_group ))
      ).subscribe({
        next: materials => this.materials = this.sortArray<Material>(materials, 'description'),
        error: (e) => {
          this.mensaje = 'Error en el servidor al cargar los materiales, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
    }

    if (this.currentPath.includes('/batch-detail') || this.currentPath.includes('/batch-update')) {
      forkJoin([this.loteCabotajeService.getCabotageBatch(this.bachId), this.loteCabotajeService.getCabotageBatchFile(this.bachId), this.loteCabotajeService.getCabotagePreviousRegistration(this.bachId), this.loteCabotajeService.getCabotageEmbargoedMerchandise(this.bachId)])
      .subscribe({
        next: ([batch, responseFileBatch, previousRegistration, embargoedMerchandise]) => {
          this.exportationBatch = batch[0];
          this.exportationBatchForm.reset({
            ...this.exportationBatch
          });
          this.loteService.getCustomerBusinessName(this.exportationBatch!.customer_id).subscribe( customerBusinessName => this.customersBusinessName = [...customerBusinessName]);
          this.loteService.getMaterial( `${this.exportationBatch!.material_group_id}` ).subscribe( materials => this.materials = this.sortArray<Material>(materials, 'description'));
          this.exportationBatch.keys_files?.forEach( key => {
            const punto = key.lastIndexOf(".");
            const annexNumber = Number(key.charAt(punto - 1));
            if (this.exportationBatch.registry_number) {
              this.loteCabotajeService.getAnnexFile(this.exportationBatch.registry_number, annexNumber)
              .subscribe({
                next: file => {
                  this.annexUrls[annexNumber - 1] = file.url ? file.url : '';
                },
                error: (e) => {
                  this.mensaje = 'Error en el servidor al cargar los anexos, inténtelo más tarde';
                  this.icono = 'bi bi-exclamation-circle-fill';
                  this.buttons = false;
                  this.overlay = true;
                  setTimeout(() => {
                    this.overlay = false;
                  }, 3000);
                },
              });
            }
          });
          if (this.currentPath.includes('/batch-detail')) {
            this.loteService.getCustomerBusinessName( this.exportationBatch.customer_id )
            .subscribe({
              next: customerBusinessName => {
                const customer = customerBusinessName.find( item => item.id_business_name == this.exportationBatch.id_business_name )
                if (customer) {
                  this.client_name = customer.business_name;
                }
              },
              error: (e) => {
                this.mensaje = 'Error en el servidor al cargar las razones sociales, inténtelo más tarde';
                this.icono = 'bi bi-exclamation-circle-fill';
                this.buttons = false;
                this.overlay = true;
                setTimeout(() => {
                  this.overlay = false;
                }, 3000);
              },
            });
          }
          if (responseFileBatch.url) {
            this.file.url = responseFileBatch.url;
          }
          this.previousRegistration = [...previousRegistration];
          this.embargoedMerchandise = [...embargoedMerchandise];

          this.embargoedMerchandise = [...embargoedMerchandise];
          const camposRegistro: PreviousRegistrationSampleCollection[] = [];
          const camposEmbargos: CustomsEmbargoedMerchandise[] = [];
          this.previousRegistration.forEach( registro => {
            this.agregarFormGroup('registro');
            camposRegistro.push({
              trade_number: registro.trade_number,
              sampling_date: registro.sampling_date,
              sample_weight: Number(registro.sample_weight)
            });
          });
          this.embargoedMerchandise.forEach( embargo => {
            this.agregarFormGroup('sinRequired');
            camposEmbargos.push({
              trade_number: embargo.trade_number,
              office_date: embargo.office_date,
              weight_embargoed_merchandise: Number(embargo.weight_embargoed_merchandise),
              filepath: embargo.filepath,
            });
            this.loteCabotajeService.getCabotageEmbargoedFile(embargo.lot_registration_number, embargo.id)
            .subscribe({
              next: (file) => {
                if (file.url) {
                  this.filesUrl.push(file.url);
                }
              },
              error: (e) => {
                this.mensaje = 'Error en el servidor al descargar el archivo, inténtelo más tarde';
                this.icono = 'bi bi-exclamation-circle-fill';
                this.buttons = false;
                this.overlay = true;
                setTimeout(() => {
                  this.overlay = false;
                }, 3000);
              },
            });
          });
          this.exportationBatchForm.reset({
            ...this.exportationBatchForm.value,
            previous_registration_sample_collection: [...camposRegistro],
            customs_embargoed_merchandise: [...camposEmbargos],
          });
          this.exportationBatchForm.get('address_business')?.disable();
          if (this.router.url.includes('ship-list')) {
            this.exportationBatchForm.get('customer_id')?.disable();
            this.exportationBatchForm.get('material_group_id')?.disable();
          }
          if (this.currentPath.includes('/batch-detail')) {
            this.exportationBatchForm.disable();
          }
          this.loading = false;
        },
        error: (e) => {
          this.loading = false;
          this.overlayError = true;
        },
      });
    }
  }

  /**
   * Valida y envía el formulario para crear o actualizar el lote de cabotaje,
   * mostrando los mensajes de éxito o error y redirigiendo al finalizar.
   */
  saveExportationBatch() {
    if( this.exportationBatchForm.invalid ) {
      this.exportationBatchForm.markAllAsTouched();
      this.mensaje = 'Favor de verificar la información';
      this.icono = 'bi bi-exclamation-circle-fill';
      this.buttons = false;
      this.overlay = true;
      setTimeout(() => {
        this.overlay = false;
      },2000);
      return;
    }
    this.loading = true;
    if (this.router.url.includes('ship-list')) {
      this.exportationBatchForm.get('customer_id')?.enable();
      this.exportationBatchForm.get('material_group_id')?.enable();
    }
    this.material = this.exportationBatchForm.get('material_id')?.value;
    this.id_business_name = this.exportationBatchForm.get('id_business_name')?.value;
    this.setValues('packing_id', 'packaging', this.packagings, true)
    this.setValues('material_id', 'material_name', this.materials, false);
    this.setValues('material_group_id', 'material_group_name', this.materialGroups, false);
    const batch = {
      address_business: this.exportationBatch.address_business,
      ...this.exportationBatchForm.value,
      customer_id: Number(this.exportationBatchForm.get('customer_id')?.value),
      id_business_name: Number(this.exportationBatchForm.get('id_business_name')?.value),
      quantity_pieces: this.exportationBatchForm.get('quantity_pieces')?.value ? Number(this.exportationBatchForm.get('quantity_pieces')?.value) : 0,
      material_id: Number(this.exportationBatchForm.get('material_id')?.value),
      material_group_id: Number(this.exportationBatchForm.get('material_group_id')?.value),
      special_storage_rate: Number(this.exportationBatchForm.get('special_storage_rate')?.value),
      commercial_value: Number(this.exportationBatchForm.get('commercial_value')?.value) || 0,
      volume_occupied_merchandise: Number(this.exportationBatchForm.get('volume_occupied_merchandise')?.value),
      annex_files: this.annex_files,
    };
    if (this.router.url.includes('ship-list')) {
      batch.operation_id = this.blDetails.operation_id;
      this.exportationBatchForm.get('customer_id')?.disable();
      this.exportationBatchForm.get('material_group_id')?.disable();
    }
    if (!this.exportationBatchForm.get('quantity_pieces')?.value) {
      batch.quantity_pieces = 0;
    }
    if (this.bachId) {
      batch.registry_number = this.bachId;
      this.loteCabotajeService.updateCabotageBatch(batch)
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (typeof response === 'object' && response.hasOwnProperty('error')) {
            const resp: any = response;
            this.mensaje = resp.message.includes('tonnage')
              ? 'La suma de toneladas registradas es mayor a las toneladas totales del barco'
              : resp.message.includes('pieces')
              ? 'La suma de piezas es mayor a las piezas totales del barco'
              : 'Lo sentimos no fue posible actualizar el lote, inténtelo más tarde';
            this.icono = 'bi bi-exclamation-circle-fill';
            this.overlay = true;
            this.buttons = false;
            setTimeout(() => {
              this.overlay = false;
            }, 3000);
            return;
          }
          this.mensaje = 'El lote fue actualizado correctamente';
          this.icono = 'bi bi-check2';
          this.overlay = true;
          this.buttons = false;
          setTimeout(() => {
            this.overlay = false;
            if (this.router.url.includes('ship-list')) {
              this.router.navigate([`/ship-list/${this.blDetails.operation_number}`]);
            } else {
              this.router.navigate(['/cabotage/batch-list'])
            }
          }, 1500);
        },
        error: (e) => {
          this.loading = false;
          this.mensaje = 'Error en el servidor al actualizar el registro, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.buttons = false;
          this.overlay = true;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
        },
      });
      return;
    }
    this.loteCabotajeService.createCabotageBatch(batch)
    .subscribe({
      next: (response) => {
        this.loading = false;
        if (typeof response === 'object' && response.hasOwnProperty('error')) {
          const resp: any = response;
          this.mensaje = resp.message.includes('tonnage')
            ? 'La suma de toneladas registradas es mayor a las toneladas totales del barco'
            : resp.message.includes('pieces')
            ? 'La suma de piezas es mayor a las piezas totales del barco'
            : 'Lo sentimos no fue posible agregar el lote, inténtelo más tarde';
          this.icono = 'bi bi-exclamation-circle-fill';
          this.overlay = true;
          this.buttons = false;
          setTimeout(() => {
            this.overlay = false;
          }, 3000);
          return;
        }
        this.mensaje = 'El lote fue agregado correctamente';
        this.icono = 'bi bi-check2';
        this.overlay = true;
        this.buttons = false;
        setTimeout(() => {
          this.overlay = false;
          if (this.router.url.includes('ship-list')) {
            this.router.navigate([`/ship-list/${this.blDetails.operation_number}`]);
          } else {
            this.router.navigate(['/cabotage/batch-list'])
          }
        }, 1500);
      },
      error: (e) => {
        this.loading = false;
        this.mensaje = 'Error en el servidor al crear el registro, inténtelo más tarde';
        this.icono = 'bi bi-exclamation-circle-fill';
        this.buttons = false;
        this.overlay = true;
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
      },
    });
  }

  /**
   * Procesa el archivo de una mercancía embargada validando su tamaño y convirtiéndolo a base64.
   * @param event - Evento del input de tipo archivo.
   * @param index - Índice del registro de mercancía embargada dentro del arreglo del formulario.
   * @param campo - Nombre del campo asociado al archivo.
   */
  fileInput(event: any, index: number, campo: string): void {
    if (event.target.files[0]) {
      if (event.target.files[0].size > 15 * 1024 * 1024) {
        switch (campo) {
          case 'customs_embargoed_merchandise':
            this.errorMessage = 'El archivo tiene que ser menos a 15mb';
            break;
          default:
            break;
        }
        this.exportationBatchForm.get(`customs_embargoed_merchandise.${index}.file`)?.setValue('');
        return;
      }
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const cadena = reader.result?.toString() || '';
        const contenidoBase64 = cadena.split(',')[1];
        this.exportationBatchForm.get(`customs_embargoed_merchandise.${index}.file`)?.setValue(contenidoBase64);
      }
    } else {
      switch (campo) {
        case 'customs_embargoed_merchandise':
          this.errorMessage = 'Ingrese el archivo';
          this.exportationBatchForm.get(`customs_embargoed_merchandise.${index}.file`)?.setValue('');
          break;
        default:
          break;
      }
    }
  }

  /**
   * Procesa un archivo simple del formulario del lote validando su tamaño y convirtiéndolo a base64.
   * @param event - Evento del input de tipo archivo.
   * @param campo - Nombre del control del formulario donde se asigna el archivo.
   */
  fileInputSimple(event: any, campo: string) {
    if (event.target.files[0]) {
      if (event.target.files[0].size > 20 * 1024 * 1024) {
        switch (campo) {
          case 'file_cabotage_batch':
            this.mensajeError2 = 'El archivo tiene que ser menos a 20mb';
            this.maxSize2 = true;
            break;
        }
        this.exportationBatchForm.get(campo)?.setValue('');
        return;
      }
      this.maxSize2 = false;
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const cadena = reader.result?.toString() || '';
        const contenidoBase64 = cadena.split(',')[1];
        this.exportationBatchForm.get(campo)?.setValue(contenidoBase64);
      }
    } else {
      switch (campo) {
        case 'file_cabotage_batch':
          this.mensajeError2 = 'Ingrese el archivo del ticket de báscula';
          break;
      }
      this.exportationBatchForm.get(campo)?.setValue('');
    }
  }

  /**
   * Procesa un archivo anexo del lote validando su tamaño y convirtiéndolo a base64.
   * @param event - Evento del input de tipo archivo.
   * @param index - Índice del anexo dentro del arreglo de archivos anexos.
   */
  fileAnnex(event: any, index: number) {
    if (event.target.files[0]) {
      if (event.target.files[0].size > 20 * 1024 * 1024) {
        switch (index) {
          case 0:
            this.errorAnnex1 = 'El archivo tiene que ser menos a 20mb';
            this.maxSizeAnnex1 = true;
            break;
          case 1:
            this.errorAnnex2 = 'El archivo tiene que ser menos a 20mb';
            this.maxSizeAnnex2 = true;
            break;
          case 2:
            this.errorAnnex3 = 'El archivo tiene que ser menos a 20mb';
            this.maxSizeAnnex3 = true;
            break;
          case 3:
            this.errorAnnex4 = 'El archivo tiene que ser menos a 20mb';
            this.maxSizeAnnex4 = true;
            break;
          case 4:
            this.errorAnnex5 = 'El archivo tiene que ser menos a 20mb';
            this.maxSizeAnnex5 = true;
            break;
        }
        this.annex_files[index].file = '';
        return;
      }
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const cadena = reader.result?.toString() || '';
        const contenidoBase64 = cadena.split(',')[1];
        this.annex_files[index].file = contenidoBase64;
      }
    } else {
      switch (index) {
        case 0:
          this.errorAnnex1 = '';
          break;
        case 1:
          this.errorAnnex2 = '';
          break;
        case 2:
          this.errorAnnex3 = '';
          break;
        case 3:
          this.errorAnnex4 = '';
          break;
        case 4:
          this.errorAnnex5 = '';
          break;
      }
      this.annex_files[index].file = '';
    }
  }

  /**
   * Agrega un nuevo grupo de campos al arreglo correspondiente del formulario (registros previos o mercancías embargadas).
   * @param array - Tipo de arreglo al que se agrega el grupo ('registro', 'sinRequired' u otro).
   */
  agregarFormGroup( array: string ): void {
    if( array === 'sinRequired') {
      this.mercanciasEmbargadasAduanaArr.push(this.fb.group({
        trade_number: [, [Validators.required, Validators.maxLength(20), Validators.pattern(/^[0-9]\d{0,29}$/)]],
        office_date: [, [Validators.required, this.dateValidator]],
        weight_embargoed_merchandise: [, [Validators.required, Validators.pattern(/^\d+(\.\d{1,3})?$/)]],
        file: [],
        filepath: [],
      }));
      return
    }
    if( array === 'registro') {
      this.registrosPreviosTomaMuestraArr.push(this.fb.group({
        trade_number: [, [Validators.required, Validators.maxLength(20), Validators.pattern(/^[0-9]\d{0,29}$/)]],
        sampling_date: [, [Validators.required, this.dateValidator]],
        sample_weight: [, [Validators.required, Validators.pattern(/^\d+(\.\d{1,3})?$/)]],
      }));
    } else {
      this.mercanciasEmbargadasAduanaArr.push(this.fb.group({
        trade_number: [, [Validators.required, Validators.maxLength(20), Validators.pattern(/^[0-9]\d{0,29}$/)]],
        office_date: [, [Validators.required, this.dateValidator]],
        weight_embargoed_merchandise: [, [Validators.required, Validators.pattern(/^\d+(\.\d{1,3})?$/)]],
        file: [, [Validators.required]],
        filepath: [],
      }));
    }
  }

  /**
   * Validador que comprueba que la fecha del control no sea anterior a la fecha de atraque del barco.
   * @param control - Control de formulario cuya fecha se valida.
   * @returns Un objeto de errores de validación si la fecha es inválida; de lo contrario `null`.
   */
  dateValidator = ( control: FormControl ): ValidationErrors | null => {
    const date = new Date(control.value);
    if (date < new Date(this.blDetails.docking_date)) {
      return {
        noValid: true
      }
    }
    return null;
  }

  /**
   * Elimina el último grupo de campos del arreglo correspondiente del formulario.
   * @param array - Tipo de arreglo del cual se elimina el grupo ('registro' u otro).
   */
  eliminarFormGroup( array: string): void {
    if( array === 'registro') {
      const index: number = this.registrosPreviosTomaMuestraArr.length - 1;
      this.registrosPreviosTomaMuestraArr.removeAt(index);
    } else {
      const index: number = this.mercanciasEmbargadasAduanaArr.length - 1;
      this.mercanciasEmbargadasAduanaArr.removeAt(index);
    }
  }

  /**
   * Indica si un campo de un arreglo del formulario es inválido y ha sido tocado por el usuario.
   * @param nameArray - Nombre del arreglo del formulario.
   * @param index - Índice del grupo dentro del arreglo.
   * @param nameField - Nombre del campo a validar.
   * @param date - Indica si la validación corresponde a un error de fecha.
   * @returns `true` si el campo es inválido y fue tocado; de lo contrario `null` o `false`.
   */
  arrayValido( nameArray: string, index: number, nameField: string, date?: boolean): boolean | null {
    if (date) {
      return this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.hasError('dateValidator') && this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.touched
    }
    return this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.errors && this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.touched
  }

  /**
   * Indica si un campo del formulario es inválido y ha sido tocado por el usuario.
   * @param campo - Nombre del control del formulario a validar.
   * @returns `true` si el campo tiene errores y fue tocado; de lo contrario `null` o `false`.
   */
  isValidField( campo: string): boolean | null {
    return this.exportationBatchForm.get(campo)!.errors &&
    this.exportationBatchForm.get(campo)!.touched;
  }

  /**
   * Indica si el anexo en el índice indicado no tiene archivo cargado.
   * @param index - Índice del anexo a validar.
   * @returns `true` si el anexo no tiene archivo; de lo contrario `false`.
   */
  isValidAnnex(index: number) {
    if (!this.annex_files[index].file) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Indica si un campo de fecha de un arreglo del formulario tiene el tipo de error indicado y fue tocado.
   * @param nameArray - Nombre del arreglo del formulario.
   * @param index - Índice del grupo dentro del arreglo.
   * @param nameField - Nombre del campo de fecha a validar.
   * @param typeError - Tipo de error a evaluar (por ejemplo, 'required').
   * @returns `true` si el campo tiene el error indicado y fue tocado; de lo contrario `null` o `false`.
   */
  dateValid( nameArray: string, index: number, nameField: string, typeError: string): boolean | null {
    if (typeError === 'required') {
      return this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.hasError('required') && this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.touched
    }
    if (this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.hasError('required')) {
      return false;
    }
    return this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.hasError('noValid') && this.exportationBatchForm.get(`${nameArray}.${index}.${nameField}`)!.touched
  }

  /**
   * Alterna la visibilidad de los campos correspondientes a la regla 2.3.8.
   */
  fieldsHiden() {
    this.rule238 = !this.rule238;
    if (this.rule238) {
      this.textRule238 = 'Ocultar regla 2.3.8';
    } else {
      this.textRule238 = 'Mostrar regla 2.3.8';
    }
  }

  /**
   * Regresa a la vista anterior en el historial de navegación.
   */
  goBack(): void {
    this.location.back()
  }

  /**
   * Ordena un arreglo de manera ascendente según la clave indicada.
   * @param array - Arreglo de elementos a ordenar.
   * @param key - Clave del elemento por la cual se ordena.
   * @returns El arreglo ordenado.
   */
  sortArray<T>(array: T[], key: keyof T): T[] {
    return array = array.sort(function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    });
  }

  /**
   * Asigna al formulario el nombre descriptivo correspondiente a un identificador seleccionado de un catálogo.
   * @param campoId - Nombre del control que contiene el identificador.
   * @param campo - Nombre del control donde se asigna el nombre descriptivo.
   * @param array - Catálogo de elementos donde se busca la descripción.
   * @param changeNumber - Indica si el identificador debe convertirse a número.
   */
  setValues( campoId: string, campo: string, array: any, changeNumber: boolean = false ): void {
    if (changeNumber) {
      this.exportationBatchForm.get(campoId)?.setValue(Number(this.exportationBatchForm.get(campoId)?.value));
    }
    if (campoId !== 'location_id') {
      const valor = array.find( (item: any) => item.id == Number(this.exportationBatchForm.get(campoId)?.value));
      this.exportationBatchForm.get(campo)?.setValue(valor?.description);
    }
  }

  /**
   * Ajusta los validadores del campo de piezas según el tipo de empaque seleccionado.
   */
  changePacking() {
    if (this.exportationBatchForm.get('packing_id')?.value != 1) {
      this.exportationBatchForm.get('quantity_pieces')?.addValidators([Validators.required]);
      this.asterico = '*';
    } else {
      this.exportationBatchForm.get('quantity_pieces')?.clearValidators();
      this.asterico = '';
    }
    this.exportationBatchForm.get('quantity_pieces')?.updateValueAndValidity();
  }

  /**
   * Asigna la dirección del negocio a partir de la razón social seleccionada.
   */
  changeRazonSocial() {
    if (this.exportationBatchForm.get('id_business_name')?.value) {
      const razonScoial = this.customersBusinessName.find( cliente => this.exportationBatchForm.get('id_business_name')?.value == cliente.id_business_name);
      if (razonScoial) {
        this.exportationBatchForm.get('address_business')?.setValue(razonScoial.address);
        if (!razonScoial.address) {
          this.exportationBatchForm.get('address_business')?.enable();
        }
        this.exportationBatch.address_business = razonScoial.address;
      }
    } else {
      this.exportationBatchForm.get('address_business')?.setValue('');
    }
  }

}
